import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
var key = new PluginKey('focusPluginHandler');
var focusPlugin = function focusPlugin(_ref) {
  var api = _ref.api;
  return {
    name: 'focus',
    getSharedState: function getSharedState(editorState) {
      var _key$getState;
      if (!editorState) {
        return {
          hasFocus: false
        };
      }
      return {
        hasFocus: Boolean((_key$getState = key.getState(editorState)) === null || _key$getState === void 0 ? void 0 : _key$getState.hasFocus)
      };
    },
    pmPlugins: function pmPlugins() {
      var _plugin = new SafePlugin({
        key: key,
        state: {
          init: function init() {
            return {
              hasFocus: false
            };
          },
          apply: function apply(tr, oldPluginState) {
            var meta = tr.getMeta(key);
            if (typeof meta === 'boolean') {
              if (meta !== oldPluginState.hasFocus) {
                return {
                  hasFocus: meta
                };
              }
            }
            return oldPluginState;
          }
        },
        props: {
          handleDOMEvents: {
            focus: function focus(view) {
              var focusState = key.getState(view.state);
              if (!(focusState !== null && focusState !== void 0 && focusState.hasFocus)) {
                view.dispatch(view.state.tr.setMeta(key, true));
              }
              return false;
            },
            blur: function blur(view) {
              var focusState = key.getState(view.state);
              if (focusState !== null && focusState !== void 0 && focusState.hasFocus) {
                view.dispatch(view.state.tr.setMeta(key, false));
              }
              return false;
            }
          }
        }
      });
      return [{
        name: 'focusHandlerPlugin',
        plugin: function plugin() {
          return _plugin;
        }
      }];
    }
  };
};
export { focusPlugin };